import { Card, CardHeader, CardContent, Typography, Box, Button } from "@mui/material"

import { Users,CheckCircle, ArrowRight } from "lucide-react"
import { NavLink } from "react-router-dom"
import ArrowForwardIcon from "@mui/icons-material/ArrowForward"
const textColor = "#0d2561"
const itextColor = "#707070"
export default function PartnersActivityWidget() {
  const data = {
    activePartners: 18,
    dealsStarted: 25,
    dealsClosed: 15,
  }

  return (
    <Card>
      
      <CardContent >
        <Typography variant="h6" sx={{ color: textColor, mb: 1 }}>
          Partners Activity
        </Typography>
        <Typography variant="body2" sx={{ color: itextColor, mb: 2 }}>
          Activities of partners working on deals.
        </Typography>
        <Box display="flex" alignItems="center" gap={1} mt={1}>
          <Users className="h-5 w-5 text-primary" />          
          <Typography variant="h6" color="text-primary">
            {data.activePartners}
          </Typography>
        </Box>
        <Typography variant="body2" color={itextColor} ml={4} mb={2}>
          Active Partners
        </Typography>

        <Box display="flex" alignItems="center" gap={1}>
          <CheckCircle className="h-5 w-5" style={{color:"#16a34a", fontWeight:600}} />
          <Typography variant="h6" sx={{ color: "#16a34a",fontWeight:'bold' }}>
            {data.dealsStarted}
          </Typography>
        </Box>
        <Typography variant="body2" color="text.secondary" ml={4} mb={2}>
          Deals Started
        </Typography>

        <Box display="flex" alignItems="center" gap={1}>
           <CheckCircle className="h-5 w-5" style={{color:"#2563eb", fontWeight:600}} />
         
          <Typography variant="h6" sx={{ color: "#2563eb",fontWeight:'bold' }}>
            {data.dealsClosed}
          </Typography>
        </Box>
        <Typography variant="body2" color="text.secondary" ml={4}>
          Deals Closed
        </Typography>

       <Box textAlign="right" marginTop="48px">
          <NavLink to="#" style={{ textDecoration: "none" }}>
            <Button
              variant="text"
              size="small"
              endIcon={<ArrowForwardIcon />}
              sx={{
                textTransform: "none",
                fontSize: "0.875rem",
                p: 0,
                minHeight: "auto",
                color: textColor
              }}
            >
              View all activites
            </Button>
          </NavLink>
        </Box>
      </CardContent>
    </Card>
  )
}
